import { apiClient } from "../../utils/apiClient";
import { downloadBlobFromResponse } from "../../utils/download";

interface ExportShipmentsParams {
  tags?: string[];
  search?: string;
  format: "xlsx";
}

/**
 * Export shipments to XLSX file
 * Makes POST request and downloads the blob
 */
export async function exportShipmentsToXlsx(
  params: ExportShipmentsParams
): Promise<void> {
  // Make POST request with blob response
  const response = (await apiClient.postWithFullResponse<Blob>(
    "/shipments/export/",
    params,
    {
      responseType: "blob",
    }
  )) as { data: Blob; headers: any };

  // Download the blob with filename from response headers
  downloadBlobFromResponse(response, "shipments-export.xlsx");
}
